import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-lead-field',
  imports: [SharedModule],
  templateUrl: './delete-lead-field.component.html',
  styleUrl: './delete-lead-field.component.scss'
})
export class DeleteLeadFieldComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Output() reload = new EventEmitter<any>();
  @Input()  editLeadFieldData: any;
  isLoading: boolean = false;

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private messageService : MessageService
  ) { }

  ngOnInit() {
    // Check if this is a fixed field and prevent deletion
    if (this.editLeadFieldData?.is_fixed) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Cannot Delete', 
        detail: 'Fixed fields cannot be deleted. You can only edit their labels.' 
      });
      setTimeout(() => {
        this.handleCloseDialog();
      }, 2000);
    }
  }

  handleDelete() {

    // Double check if it's a fixed field
    if (this.editLeadFieldData?.is_fixed) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Cannot Delete', 
        detail: 'Fixed fields cannot be deleted.' 
      });
      return;
    }

    const paylaod = {
      field_id : this.editLeadFieldData.field_id,
      organization_id: this.localStorage.getOrganizationId()
    }

    this.isLoading = true;

    this.api.deleteLeadField(paylaod).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Field Deleted Successfully' });
        this.handleCloseDialog();
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while deleting lead field' });
        console.log(error);
      }
    }
    );
  }



  handleCloseDialog() {
    this.closeDialog.emit();
  }

}
